import { gql } from '@apollo/client';

const query = gql`
  mutation addReviewAsset($input: AddReviewAssetInput!) {
    addReviewAsset(input: $input) {
      reviewAsset {
        id
        url
      }
    }
  }
`;

module.exports = query;
